module.exports = __webpack_public_path__ + "static/media/Rubik-BlackItalic.a96c8f00.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shoutem/ui/fonts/Rubik-BlackItalic.ttf
// module id = 1259
// module chunks = 0